import React, { useState, useEffect } from "react";
import { Row, Col, Card, message, Divider, Table, Input, Space, Tag, Typography, Select, DatePicker } from "antd";
import { SearchOutlined, FileDoneOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../../services/http";
import dayjs from "dayjs";
const { Text } = Typography;

// STATUS
const options_status = [
  { value: 999, label: "Todos" },
  { value: 0, label: "Inativo" },
  { value: 1, label: "Ativo" },
];

// CONFIRMAÇÃO
const options_confirmacao = [
  { value: 999, label: "Todos" },
  { value: 0, label: "Não Confirmados" },
  { value: 1, label: "Confirmados" },
];

export const ReciboFeriasRelatorio = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  const [optionsFiliais, setOptionsFiliais] = useState([]);

  // FILTRO
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState(999);
  const [confirmacao, setConfirmacao] = useState(0);
  const [filial, setFilial] = useState(999);

  // FILTRO PERÍODO
  const [dataInicio, setDataInicio] = useState(dayjs().startOf("year"));
  const [dataFim, setDataFim] = useState(dayjs());

  useEffect(() => {
    listarFiliais();
    listarRecibosFerias(dataInicio, dataFim);
  }, [dataInicio, dataFim]);

  // LISTAR
  const listarRecibosFerias = async (dataInicio, dataFim) => {
    setLoading(true);
    const data_i = dayjs(dataInicio).format("YYYY-MM-DD");
    const data_f = dayjs(dataFim).format("YYYY-MM-DD");

    const api = await http("get", `v1/recibo_ferias/listar_todos?data_i=${data_i}&data_f=${data_f}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR FILIAIS
  const listarFiliais = async () => {
    setLoading(true);
    const api = await http("get", `v1/recibo_ferias/listar_filiais`, []);
    if (api.statusCode === 200) {
      let options_filiais = [{ value: 999, label: "Todas" }];
      if (api?.response?.data) {
        api?.response?.data?.forEach((e) => {
          options_filiais.push({ label: e.descricao, value: e.id });
        });
      }
      setOptionsFiliais(options_filiais);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      dataIndex: "colaborador",
      title: "Colaborador",
      sorter: (a, b) => a.colaborador?.toString()?.localeCompare(b.colaborador),
    },
    {
      dataIndex: "filial",
      title: "Filial",
      sorter: (a, b) => a.filial?.toString()?.localeCompare(b.filial),
    },
    {
      key: "inifer",
      title: "Início Férias",
      render: (_, e) => dayjs(e.inifer).format("DD/MM/YYYY"),
      sorter: (a, b) =>
        dayjs(a.inifer).format("DD/MM/YYYY")?.toString()?.localeCompare(dayjs(b.inifer).format("DD/MM/YYYY")),
    },
    {
      key: "status",
      title: "Status",
      render: (_, e) => (e.status ? <Tag color="green">Ativo</Tag> : <Tag color="red">Inativo</Tag>),
      sorter: (a, b) => (a.status === 1 ? "Ativo" : "Inativo")?.localeCompare(b.status === 1 ? "Ativo" : "Inativo"),
    },
    {
      key: "status_confirmacao",
      title: "Confirmado",
      render: (_, e) =>
        e.status_confirmacao === 1 ? <Tag color="green">Confirmado</Tag> : <Tag color="red">Pendente</Tag>,
      sorter: (a, b) => a.status_confirmacao?.toString()?.localeCompare(b.status_confirmacao?.toString()),
    },
    {
      key: "data_confirmacao",
      title: "Data Conf.",
      render: (_, e) => (e.data_confirmacao ? dayjs(e.data_confirmacao).format("DD/MM/YYYY") : "-"),
      sorter: (a, b) =>
        dayjs(a.data_confirmacao)
          .format("DD/MM/YYYY")
          ?.toString()
          ?.localeCompare(dayjs(b.data_confirmacao).format("DD/MM/YYYY")),
    },
    {
      key: "visualizado",
      title: "Visualizado",
      render: (_, e) => (e.visualizado > 0 ? <Tag color="green">Sim</Tag> : <Tag color="red">Não</Tag>),
      sorter: (a, b) => a.visualizado?.toString()?.localeCompare(b.visualizado?.toString()),
    },
    {
      key: "data_visualizacao",
      title: "Data Vis.",
      render: (_, e) => (e.data_visualizacao ? dayjs(e.data_visualizacao).format("DD/MM/YYYY") : "-"),
      sorter: (a, b) =>
        dayjs(a.data_visualizacao)
          .format("DD/MM/YYYY")
          ?.toString()
          ?.localeCompare(dayjs(b.data_visualizacao).format("DD/MM/YYYY")),
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar, filtro_status, filtro_confirmacao, filtro_filial) => {
    let filteredData = dados?.filter(
      (val) =>
        dayjs(val.inifer).format("DD/MM/YYYY")?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        dayjs(val.data_visualizacao).format("DD/MM/YYYY")?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.filial?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.colaborador?.toLowerCase().includes(pesquisar.toLowerCase())
    );

    // FILIAL
    if (filtro_filial !== 999) {
      filteredData = filteredData.filter((e) => e.id_filial === filtro_filial);
    }

    // SETOR
    if (filtro_confirmacao !== 999) {
      filteredData = filteredData.filter((e) => e.status_confirmacao === filtro_confirmacao);
    }

    // CARGO
    if (filtro_status !== 999) {
      filteredData = filteredData.filter((e) => e.status === filtro_status);
    }

    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search, status, confirmacao, filial) : [];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Documentos" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title="Recibos de Férias Relatório"
              loading={loading}
              subtitle={"Consultar recibos de férias"}
              icon={<FileDoneOutlined />}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space direction="vertical">
                <Space wrap>
                  <Space direction="vertical" size={0}>
                    <Text style={{ fontSize: 12 }} type="secondary">
                      Pesquisar:
                    </Text>
                    <Input
                      size="middle"
                      maxLength={100}
                      prefix={<SearchOutlined />}
                      className="input"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      placeholder="Pesquisar..."
                      allowClear
                    />
                  </Space>
                  <Space direction="vertical" size={0}>
                    <Text style={{ fontSize: 12 }} type="secondary">
                      Status:
                    </Text>
                    <Select
                      defaultValue={0}
                      disabled={loading}
                      value={status}
                      style={{ width: 180, maxWidth: "100%" }}
                      onChange={(e) => setStatus(e)}
                      options={options_status}
                    />
                  </Space>
                  <Space direction="vertical" size={0}>
                    <Text style={{ fontSize: 12 }} type="secondary">
                      Confirmação:
                    </Text>
                    <Select
                      defaultValue={0}
                      disabled={loading}
                      value={confirmacao}
                      style={{ width: 180, maxWidth: "100%" }}
                      onChange={(e) => setConfirmacao(e)}
                      options={options_confirmacao}
                    />
                  </Space>
                  <Space direction="vertical" size={0}>
                    <Text style={{ fontSize: 12 }} type="secondary">
                      Filial:
                    </Text>
                    <Select
                      defaultValue={0}
                      disabled={loading}
                      value={filial}
                      style={{ width: 180, maxWidth: "100%" }}
                      onChange={(e) => setFilial(e)}
                      options={optionsFiliais}
                      showSearch
                      filterOption={(input, option) =>
                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Space>
                  <Space direction="vertical" size={0}>
                    <Text style={{ fontSize: 12 }} type="secondary">
                      Período:
                    </Text>
                    <Space wrap>
                      <DatePicker
                        onChange={(e) => setDataInicio(e)}
                        value={dataInicio}
                        format={"DD/MM/YYYY"}
                        disabled={loading}
                      />
                      <span>-</span>
                      <DatePicker
                        onChange={(e) => setDataFim(e)}
                        value={dataFim}
                        format={"DD/MM/YYYY"}
                        disabled={loading}
                      />
                    </Space>
                  </Space>
                </Space>
              </Space>

              <Divider />

              <Table
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
                rowKey="id"
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
